module.exports = __webpack_public_path__ + "img/pocket-tablet_en.fc45cfc.jpg";